
<template>
  <div>
      <div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Meeza Payment </a></h1>

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Payment list </div>
<div class="panal-body " >
    <div class="table table-responsive col-md-10  m-auto">
        <table  id="ChargesTable" border="1"  class="tabel" width="100%">
            <thead>
                <tr class="text-uppercase jumbotron" style="text-transform:capitalize">
                    
                    <th align="center" class="text-center"><strong>Payment Name</strong></th>
                    <th align="center" class="text-center"><strong>Value</strong></th>
                </tr>
            </thead>

            <tbody class="text-center" id="ChargesTableData">
                <tr v-for="(data,index) in PaymentStore" v-bind:key="index">
                   
                    <td>{{data.Description}}
                    </td>
                   
                    <td>{{data.Price}}
                    </td>
                   
                    </tr>
                   
            </tbody>
            <tfoot></tfoot>
        </table></div>
        <p class="mt-50 alert alert-warning">  Please Review your payment List Carefully then Press Next Button Bank Fess is almost 1% of total amount </p>
        <div class="text-center"> <b-link class=" " @click="$router.push('MizaProcessPayment')">

                       <button class="btn btn-primary text-center">Next</button>
                      </b-link></div>
            <!-- <input type="image" class="mt-50" @click="GetMerchantRefNumber" src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png" alt="Edfa3 Fawry" id="xsrrs" /> -->
    </div>
    
    
  </div>
</div>
</div>
      </div>
  </div>
  
</template>

<script>

export default {
    

   data(){
       return{
        
        
       
       }
   },
   created() {
              if(this.PaymentStore.length == 0 ) this.$router.push('/wallet')
       
  },
   mounted(){
      
    
   },
   methods:
   {



   },
   computed:{
       PaymentStore(){
          
              return this.$store.state.auth.paymentList 
        },
     currentUser() {
        return this.$store.state.auth.user
      },
      reviewApplication(){
       return  this.$store.state.auth.renderReview 
       }
   }

}
</script>

<style>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-light th {

    font-size: 14px !important;
}
.mt-50{
    margin-top: 50px !important;
}
.m-auto{
    margin: auto !important;
}
</style>